import React from 'react';
import clsx from 'clsx';
export function XFormInputCheckbox(input) {
    return React.createElement("div", { className: clsx('XFormInputCheckbox') }, "XFormInputCheckbox");
}
